import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';
import { Dialog as StandaloneDialog } from '@/components/Dialog';
import { PaymentCompletedDialogTheme } from '@/components/PaymentCompletedDialog/theme';

const $ = GenericSlotFactory({ theme: PaymentCompletedDialogTheme });

const Base = $({ as: 'div', slot: 'base' });
const Dialog = GenericSlot({ as: StandaloneDialog, theme: PaymentCompletedDialogTheme.Dialog });

export const PaymentCompletedDialog = Object.assign(Base, { Dialog });
